import type Splide from "@splidejs/splide";

export function tabstoriesInit(splides: {[x: string]: Splide }) {
  // tab-stories pagination
  const tabStoriesPageLinks = document.querySelectorAll(".tab-stories .tab-stories__nav__item");

  tabStoriesPageLinks.forEach((tabStoriesLink, index) => {
    tabStoriesLink.addEventListener("click", (e) => {
      e.preventDefault();
      tabStoriesPageLinks.forEach((tabStoriesLink) => {
        tabStoriesLink.classList.remove("active");
      });
      tabStoriesLink.classList.add("active");

      const splide = splides["tab-stories"];
      if (splide) {
        splide.go(index);
      }
    });
  });

  // Check if the splies with "tab-stories" id exists. If id does, check for the changes and change the active class of the links.
  const tabStoriesSplide = splides["tab-stories"];
  if (tabStoriesSplide) {
    tabStoriesSplide.on('moved', (_newIndex, _prevIndex, destIndex) => {
      if (tabStoriesPageLinks) {
        tabStoriesPageLinks.forEach((tabStoriesLink, index) => {
          tabStoriesLink.classList.remove("active");

          if (index === destIndex) {
            tabStoriesLink.classList.add("active");
            tabStoriesLink.scrollIntoView({behavior: "smooth", inline: "center", block: "nearest"});
          }
        })
      }
    })
  }
}